import styled from '@vodafoneziggo/sandwich/theme';
import { Dropdown as StyledDropdown } from 'styled-dropdown-component';

export const Dropdown = styled(StyledDropdown)`
  display: block;
`;
